export default __webpack_public_path__ + "static/media/guobastand_bluoba.8add7822.png";